import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { bugsnagNotify } from '../utils/bugsnagClientWrapper';
import { withTranslation } from '../src/i18n';
import Custom404 from './404';
import ErrorPage from '../containers/ErrorPage';

const Error = ({ t, statusCode, error }) => {
  if (statusCode === 404) {
    return <Custom404 t={t} />;
  }
  return <ErrorPage t={t} statusCode={statusCode} error={error} />;
};

Error.propTypes = {
  statusCode: PropTypes.number,
};

Error.getInitialProps = async ({ res, err, store }) => {
  if (!isEmpty(err)) {
    // Notify if any error in any component
    const context = '_error getInitialProps';
    let diagnosticData = { context };

    if (store) {
      const state = store.getState();
      const user = get(state, 'App.userData');
      diagnosticData = { ...diagnosticData, user };
    }
    bugsnagNotify(err, diagnosticData);
  }

  const statusCode = res?.statusCode || err?.statusCode || 404;

  return {
    namespacesRequired: ['translation'],
    statusCode,
    error: err.stack,
  };
};

export default withTranslation('translation')(Error);
